import { render } from "./AllocateDialog.vue?vue&type=template&id=2046d479"
import script from "./AllocateDialog.vue?vue&type=script&lang=js"
export * from "./AllocateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__